import React, { useState } from "react";
import { NavLink , Link } from "react-router-dom";
import headerdownarrow from "../../images/general/header-downarrow.svg";
import dropdownboxuparrow from "../../images/general/dropdown-box-uparrow.svg";
import useWindowDimensions from "../../hooks/useWindowDimensions";
import SubNavItem from "./SubNavItem";

const HeaderNavItem = ({
  navData,
  navActiveIndex,
  handleNavIndex,
  arrIndex,
}) => {
  const { width } = useWindowDimensions();
  const [subIndex, setSubIndex] = useState(null);
  const handleSubIndex = (i) => {
    if (subIndex == i) {
      setSubIndex(null);
    } else {
      setSubIndex(i);
    }
  };

  if (navData.dropDownLevel === 2) {
    return (
      <li className="nav_item">
        <div
          className="nav_link_wrapper"
          onClick={() => handleNavIndex(arrIndex)}
        >
          <span className="nav_link">{navData.mainTitle}</span>
          {width >= 1024 ? (
            <img
              src={headerdownarrow}
              alt="Down arrow"
              className="headerdownarrow"
            />
          ) : (
            <span className="headerdownarrow">
              {navActiveIndex == arrIndex ? "-" : "+"}
            </span>
          )}
        </div>
        <div
          className={`dropdown_box ${
            navActiveIndex == arrIndex ? "active" : ""
          }`}
        >
          {width >= 1024 && (
            <img
              src={dropdownboxuparrow}
              alt="dropdown box up arrow"
              className="dropdownboxuparrow"
            />
          )}
          <>
            {navData.dropDownList.map((dropDownData, i) => (
              <SubNavItem
                dropDownData={dropDownData}
                key={i}
                dropDownIndex={i}
                handleSubIndex={handleSubIndex}
                subIndex={subIndex}
              />
            ))}
          </>
        </div>
      </li>
    );
  }

  if (navData.dropDownLevel === 1) {
    return (
      <li className="nav_item">
        <div
          className="nav_link_wrapper"
          onClick={() => handleNavIndex(arrIndex)}
        >
          {navData.navLink ? (
            <Link to={navData.navLink} className="nav_link">
              {navData.mainTitle}
            </Link>
          ) : (
            <span className="nav_link">{navData.mainTitle}</span>
          )}

          {width >= 1024 ? (
            <img
              src={headerdownarrow}
              alt="Down arrow"
              className="headerdownarrow"
            />
          ) : (
            <span className="headerdownarrow">
              {navActiveIndex == arrIndex ? "-" : "+"}
            </span>
          )}
        </div>
        <div
          className={`dropdown_box ${
            navActiveIndex == arrIndex ? "active" : ""
          }`}
        >
          {width >= 1024 && (
            <img
              src={dropdownboxuparrow}
              alt="dropdown box up arrow"
              className="dropdownboxuparrow"
            />
          )}
          {navData.dropDownList.map((data, i) => (
            <div className="dropdown_list_item" key={i}>
              <NavLink
                className={({ isActive }) =>
                  isActive
                    ? "dropdown_list_item_link active"
                    : "dropdown_list_item_link"
                }
                to={data.navLink}
              >
                {data.navTitle}
              </NavLink>
            </div>
          ))}
        </div>
      </li>
    );
  }

  return (
    <li className="nav_item">
      <NavLink
        className={({ isActive }) =>
          isActive ? "nav_link active" : "nav_link"
        }
        to={navData.mainLink}
      >
        {navData.mainTitle}
      </NavLink>
    </li>
  );
};

export default HeaderNavItem;
